import { useEffect, useState } from "react";
import { useStore } from "../store";
import "./Alert.css";
export default function Alert(props) {
  const alertMessage = useStore((state) => state.alertMsg);
  const showTime = 3000; //ms
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    if (alertMessage === "") {
      setVisibility(false);
      return;
    }

    setVisibility(true);
    setTimeout(() => {
      setVisibility(false);
    }, showTime);
  }, [alertMessage]);

  return visibility ? <div className="alert">{alertMessage["msg"]}</div> : null;
}
